import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState, useRef } from "react";
import './userActivityPanel.css';
import moment from "moment";
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Pagination from 'react-js-pagination';
import ReactToPrint from "react-to-print";
import notIc from "./Image/Vector_5.png";
import { useDispatch, useSelector } from "react-redux";


function UserActivityPanel(props) {

    let shouldWait = false;
    let scrollBuffer = 0;

    const [showPanel, setShowPanel] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [pageIndex, setPageIndex] = useState(1);
    const [offset, setOffset] = useState(0);
    const [read, setRead] = useState(false);
    const [operation, setOperation] = useState("");
    const [sortedIdArray, setSortedIdArray] = useState([]);
    const [selectedIdArray, setSelectedIdArray] = useState([]);
    const [totalCount, setTotalCount] = useState([]);
    const [userActivityFromDate, setUserActivityFromDate] = useState([]);
    const [userActivityToDate, setUserActivityToDate] = useState([]);
    const [moduleName, setModuleName] = useState([]);
    const [moduleId, setModuleId] = useState([]);
    const [moduleList, setModuleList] = useState([]);
    const [instituteIdArray, setInstituteIdArray] = useState([]);
    const componentRef = useRef();

    const [UserActivityList, setUserActivityList] = useState([]);
    // const [unReadMessageCount, setUnReadMessageCount] = useState([]);

    const dispatch = useDispatch();
    const AdminAccessReducer = useSelector((state) => state.AdminAccessReducer);
    const routingMenu = useSelector((state) => state.RouteMenuReducer);

    useEffect(() => {
        const userActivityContainer = document.getElementById('userActivity-container-99');
        userActivityContainer.addEventListener('scroll', handleScroll);

        apiCallToGetPMInstituteModuleList();

        return () => {
            userActivityContainer.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => { 
        if(routingMenu.iidArray?.iidArray?.length > 0){
            apiCallToGetUserActivityList()
        }
    }, [moduleId, userActivityFromDate, userActivityToDate, operation, limit, routingMenu.iidArray]);

    useEffect(() => {
        if (props.ActivityLogModal !== showPanel) {
            setShowPanel(props.ActivityLogModal);
        }
    }, [props.ActivityLogModal, showPanel]);

    // FUNCTION TO LOAD MORE
    const loadMore = () => setLimit((prev) => prev + 10);
    const clickToExport = () => document.getElementById('export-excel').click();
    const handleShowPanel = () => showPanel && setShowPanel(false)
    window.addEventListener('click', event => !document.getElementById('userActivity-container-99').contains(event.target) && handleShowPanel());

    const handleScroll = () => {
        let offsetHeight = document.getElementById('userActivity-container-99').offsetHeight;
        let scrollTop = document.getElementById('userActivity-container-99').scrollTop;

        if (scrollTop == 0) { scrollBuffer = 0; }

        if (((scrollTop - (scrollBuffer)) <= 0) || (Math.floor(offsetHeight / 3) > scrollTop)) return;

        scrollBuffer = scrollTop;
    }


    const apiCallToGetPMInstituteModuleList = async () => {
        try {
            const jsonResponse = await LibraryApiCall.makeApiCall("GetPMInstituteModuleList", {}, '/api/projectManagement/settings/moduleInformation.php');
            if (jsonResponse.success) {
                const apiResult = jsonResponse.APIResult.data;
                setModuleList(apiResult);
            } else {
                setIsLoading(true);
            }
        } catch (error) {
            console.error("Error occurred while fetching PM institute module list:", error);
        }
    };

    //  API CALL TO GET NOTIFICATION
    const apiCallToGetUserActivityList = async () => {
        try {
            setIsLoading(true);
            const formData = {
                iid: config.institute_id,
                user_role: config.account == "faculty" || config.account == "instructor" || config.account == "employee" || config.account == "teaching" || config.instructorInfo.account == "nonteaching" ? "employee" : "student",
                user_id: config.faculty_id,
                page_index: pageIndex,
                limit: limit,
                iidArray: routingMenu.iidArray.iidArray, //routingMenu.instituteIdArray,
                filterFromDate: userActivityFromDate,
                filterToDate: userActivityToDate,
                module_id: moduleId,
                operation
            };

            const jsonResponse = await LibraryApiCall.makeApiCall(
                "GetUserActivityLogs",
                formData,
                '/api/user_activity_logs.php'
            );

            if (jsonResponse.success) {
                const apiResult = jsonResponse.APIResult.data;
                const totalCount = jsonResponse.APIResult.total;
                setUserActivityList(apiResult);
                setIsLoading(false);
                setSortedIdArray(jsonResponse.APIResult.sortedIdArray);
                setTotalCount(totalCount);
                setSelectedIdArray([]);
            } else {
                setIsLoading(false); // Set isLoading to false when API call fails
            }
        } catch (error) {
            console.error("Error occurred while fetching user activity logs:", error);
            setIsLoading(false); // Set isLoading to false in case of error
        }
    };

    const userActivitySelected = (uniqueId) => {
        if (!selectedIdArray.includes(uniqueId)) {
            setSelectedIdArray([...selectedIdArray, uniqueId]);
        }
        apiCallToGetUserActivityList();
    }

    const setFromUserActivityDate = (e) => {
        let dayDifferenceValue = 1 + moment(userActivityToDate).diff(moment(e.target.value), 'days');

        setUserActivityFromDate(e.target.value);
        setUserActivityToDate('');
        apiCallToGetUserActivityList();
    };


    const setToUserActivityDate = (e) => {
        let dayDifferenceValue = 1 + moment(e.target.value).diff(moment(userActivityFromDate), 'days');

        setUserActivityToDate(e.target.value);
        apiCallToGetUserActivityList();
    };

    // METHOD TO SELECT FILTER Academic Branch
    const selectFilterModule = (e) => {
        setModuleId(e.target.value)
        setPageIndex(1)
        setOffset(0)
    }

    const selectFilterOperation = (e) => {
        setOperation(e.target.value)
        setPageIndex(1)
        setOffset(0)
    }

    const updatePaginationCount = (pageNumber) => {
        setOffset((pageNumber - 1) * limit);
        setPageIndex(pageNumber);
        setIsLoading(false);
        apiCallToGetUserActivityList();
    };

    const getFirstCharOfWords = (inputString) => {
        const wordsArray = inputString.split(' ');
        const firstCharsArray = wordsArray.map((word) => word.charAt(0));
        const result = firstCharsArray.join('');
        return result;
    }

    return (
        <div className="position-relative">
            <div
                className="mr-3 p-1 cursor-pointer"
                onClick={(e) => {
                    e.stopPropagation();
                    setShowPanel(prev => !prev);
                    props.handleModalOpenClose("userActivity");

                }}
            >
                <img src={notIc} height="25" alt="user_activity_icon"></img>
            </div>
            <div style={{
                width: showPanel ? '100vw' : '0',
                height: showPanel ? '100vh' : '0',
                backgroundColor: showPanel ? 'rgba(0, 0, 0, 0.5)' : 'transparent',
                zIndex: showPanel ? 19 : -1,
                position: 'fixed',
                top: 0,
                left: 0
            }}>
                <div
                    id='userActivity-container-99'
                    className="p-4 position-absolute d-flex flex-column transition shadow border bg-white"
                    style={{
                        width: "50vw",
                        height: showPanel ? '100vh' : '0',
                        opacity: showPanel ? 1 : 0,
                        // top: '40px',
                        right: showPanel ? '0' : '0',
                        zIndex: showPanel ? 20 : -1,
                        borderRadius: '0.7rem',
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: "space-between" }}>
                        <span className="font-weight-bold">Activities</span>
                        <FontAwesomeIcon
                            className="export-icon mr-3 "
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowPanel(prev => !prev);
                                props.handleModalOpenClose("userActivity");
                            }}
                            icon={['fas', 'times']}
                            size="lg"
                        />
                    </div>

                    <div className=" row mt-4 mb-4 " style={{ backgroundColor: '#f0f0f0', padding: '10px' }} >
                        <div className="col-md-12 mb-2" style={{ position: 'relative', zIndex: 1, display: 'flex' }}>
                            <div className="filter-userActivityStream col-md-6 d-flex " style={{ paddingRight: 0 }}>
                                <label style={{ fontWeight: 'bold', fontSize: 14, borderTop: "1px solid #DBDBDB", borderLeft: "1px solid #DBDBDB", borderBottom: "1px solid #DBDBDB", padding: "6px", borderRadius: "5px 0 0 5px", whiteSpace: 'nowrap' }}>From Date </label>
                                <input
                                    className="form-control"
                                    type="date"
                                    placeholder="Enter from date."
                                    value={userActivityFromDate}
                                    onChange={(e) => setFromUserActivityDate(e)}
                                />
                            </div>
                            <div className="filter-userActivityStream col-md-6 d-flex ml-3" style={{ paddingRight: 0, marginLeft: '110px' }}>
                                <label style={{ fontWeight: 'bold', fontSize: 14, borderTop: "1px solid #DBDBDB", borderLeft: "1px solid #DBDBDB", borderBottom: "1px solid #DBDBDB", padding: "6px", borderRadius: "5px 0 0 5px", whiteSpace: 'nowrap' }}>To Date </label>
                                <input
                                    className="form-control"
                                    type="date"
                                    placeholder="Enter from date."
                                    min={userActivityFromDate}
                                    value={userActivityToDate}
                                    onChange={(e) => setToUserActivityDate(e)}
                                />
                            </div>
                        </div>
                        <div className="row col-md-12" style={{ position: 'relative', zIndex: 1, paddingRight: 0 }}>
                            <div className="filter-userActivityStream col-md-6 d-flex " style={{ paddingRight: 0 }}>
                                <label style={{ fontWeight: 'bold', fontSize: 14, borderTop: "1px solid #DBDBDB", borderLeft: "1px solid #DBDBDB", borderBottom: "1px solid #DBDBDB", padding: "6px", borderRadius: "5px 0 0 5px", whiteSpace: 'nowrap' }}>Module</label>
                                <select
                                    className="form-control"
                                    value={moduleId}
                                    onChange={(e) => selectFilterModule(e)}
                                >
                                    <option value="">Select Module</option>
                                    {
                                        Object.keys(moduleList).length > 0 &&
                                        Object.values(moduleList).map(module => {
                                            return (
                                                <option key={module.moduleId} value={module.moduleId}>{module.module_name}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div>

                            <div className="filter-userActivityStream col-md-6 d-flex " style={{ paddingRight: 0 }}>
                                <label style={{ fontWeight: 'bold', fontSize: 14, borderTop: "1px solid #DBDBDB", borderLeft: "1px solid #DBDBDB", borderBottom: "1px solid #DBDBDB", padding: "6px", borderRadius: "5px 0 0 5px", whiteSpace: 'nowrap' }}>Operation</label>
                                <select
                                    className="form-control"
                                    value={operation}
                                    onChange={(e) => selectFilterOperation(e)}
                                >
                                    <option value="">Select Operation</option>
                                    <option value="add">Add</option>
                                    <option value="update">Update</option>
                                    <option value="delete">Delete</option>
                                </select>
                            </div>

                        </div>
                        <div className="row col-md-12" style={{ position: 'relative', zIndex: 1, padding: 0 }}>
                            <div className="col-md-6 row"></div>
                            <div className="col-md-6 row" style={{ paddingLeft: "0px", display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: 0 }}>
                                <span className="d-none">
                                    <ReactHTMLTableToExcel
                                        id="export-excel"
                                        className="download-table-xls-button"
                                        table="table-xls"
                                        filename="EmployeeLeaves"
                                        sheet="tablexls"
                                        buttonText="Export to Excel "
                                    />
                                </span>
                                {/* <button type="button" className="SyncLogs btn text-capitalize outline-button " title="Click to export" style={{marginLeft: '33px'}} >
                                    Apply
                                </button> */}
                                <button type="button" className="SyncLogs btn text-capitalize outline-button " title="Click to export" style={{ marginLeft: '15px' }} onClick={() => clickToExport()}>
                                    <FontAwesomeIcon className="export-icon mr-2" style={{ cursor: 'pointer' }} color="#0465AC" icon={['fas', 'file-excel']} size="lg" />
                                    Export
                                </button>
                                <ReactToPrint
                                    trigger={() =>
                                        <button type="button" style={{ backgroundColor: '#0465ac' }} className="btn  text-white text-capitalize pull-right" title="Click to print">
                                            <FontAwesomeIcon
                                                icon={['fas', 'print']}
                                                size="md"
                                                style={{ cursor: "pointer" }}
                                                className="mr-2 print"
                                                onClick={() => this.setState({
                                                })}
                                            />
                                            Print
                                        </button>}
                                    content={() => componentRef.current}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className='pr-2 mt-3 d-flex flex-column scrollable'
                        style={{ height: 'calc(100% - 100px)' }}
                        ref={componentRef}
                    >
                        {
                            UserActivityList.length === 0
                                ?
                                <span>No new activities.</span>
                                :
                                <>
                                    {
                                        isLoading ?
                                            (<span className="align-self-center font-weight-bold text-black-50">
                                                Loading Activities . . .&nbsp;
                                                <FontAwesomeIcon icon={['fas', 'circle-notch']} className="rotate" />
                                            </span>)
                                            :
                                            <>
                                                <table id='table-xls' >
                                                    <thead style={{ borderColor: "transparent" }} >
                                                        <tr style={{ borderRadius: "5px 5px 0px 0px " }}>
                                                            <th style={{ backgroundColor: '#f0f0f0', padding: '5px' }}><b>Sr.No.</b></th>
                                                            <th style={{ backgroundColor: '#f0f0f0', padding: '5px' }}><b>Module</b></th>
                                                            <th style={{ backgroundColor: '#f0f0f0', padding: '5px' }}><b>Title</b></th>
                                                            <th style={{ backgroundColor: '#f0f0f0', padding: '5px' }}><b>Date & Time</b></th>
                                                            <th style={{ backgroundColor: '#f0f0f0', padding: '5px' }}><b>Operation</b></th>
                                                            {/* <th style={{ backgroundColor: '#f0f0f0', padding: '5px' }}><b>Activity Performed By</b></th> */}
                                                        </tr>
                                                        {/* <tr >
                                                            <div style={{ height: 10 }}></div>
                                                        </tr> */}
                                                    </thead>

                                                    <tbody style={{ borderTop: 'none' }}>
                                                        {
                                                            sortedIdArray?.map((id, index) => {
                                                                let userActivity = UserActivityList[id];
                                                                if (userActivity) {
                                                                    // console.log(userActivity);
                                                                    return (
                                                                        <>
                                                                            <tr style={{ borderColor: "transparent", boxShadow: "0px 4px 4px rgba(4, 101, 172, 0.1)", borderRadius: "5px 5px 0px 0px", backgroundColor: "white" }} key={id}  >
                                                                                <td style={{ padding: '5px' }}>{offset + index + 1}</td>
                                                                                <td style={{ padding: '5px' }} title={userActivity.moduleName}>{userActivity.moduleName}</td>
                                                                                <td style={{ padding: '5px' }} title={userActivity.action_performed}>{userActivity.action_performed && userActivity?.action_performed?.length > 30 ? userActivity.action_performed.slice(0, 30) + '...' : userActivity.action_performed}</td>
                                                                                <td style={{ padding: '5px' }} title={userActivity.addedOn}>{userActivity.addedOn}</td>
                                                                                <td style={{ padding: '5px' }} title={userActivity.operation}>
                                                                                    <div style={{
                                                                                        backgroundColor: userActivity.operation?.toLowerCase() == 'add' ? '#D2FFD2' : userActivity.operation?.toLowerCase() == "update" ? '#FFDE9E' : '#FF9E9E',
                                                                                        borderRadius: 10,
                                                                                        paddingHorizontal: 10,
                                                                                        paddingVertical: 5,
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        alignSelf: 'flex-end',
                                                                                        // marginTop:'6px',
                                                                                        fontWeight: 'bold',
                                                                                        color: userActivity.operation?.toLowerCase() == 'add' ? '#008000' : userActivity.operation?.toLowerCase() == "update" ? '#D88E00 ' : '#FC3333',
                                                                                    }}>
                                                                                        {userActivity.operation?.toLowerCase() == 'add' ? 'Added' : userActivity.operation?.toLowerCase() == 'update' ? 'Updated' : 'Deleted'}

                                                                                    </div>
                                                                                </td>
                                                                                {/* <td style={{ padding: '5px' }} title={userActivity.userName}>
                                                                                    {userActivity.userName}
                                                                                </td> */}
                                                                            </tr>
                                                                            <tr >
                                                                                <div style={{ height: 10 }}></div>
                                                                            </tr>
                                                                        </>
                                                                    );
                                                                }
                                                                return null; // Add this line to handle the case when userActivity is falsy
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </>
                                    }


                                    {
                                        (sortedIdArray.length > 0) &&
                                        <div id="paginationContainer">
                                            <Pagination
                                                activePage={pageIndex}
                                                itemsCountPerPage={limit}
                                                totalItemsCount={totalCount}
                                                pageRangeDisplayed={3}
                                                onChange={(num) => updatePaginationCount(num)}
                                            />
                                        </div>
                                    }
                                </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserActivityPanel;
